import React from "react";
import { Label } from "semantic-ui-react";

const EventHeaderSectorLabel = ({ sector, ...props }) => (
  <Label {...props} basic icon="industry" size="large" content={sector} />
);

export default EventHeaderSectorLabel;
